export default "__VITE_ASSET__BBNXV8$n__"